<ngx-dropzone
    id="dropzone"
    class="w-100 h-100"
    [ngClass]="{
        'border border-danger': !files().length && isRequired()
    }"
    [accept]="extensionsString()"
    [disabled]="isDropzoneDisabled()"
    (click)="onDropzoneClick()"
    (change)="onFileAdd($event)">
    <ngx-dropzone-label>
        <div class="d-flex flex-column align-items-center">
            <div class="mb-4">
                <div class="d-flex align-items-center mb-2">
                    <nb-icon
                        icon="layers-outline"
                        style="width: 2rem; height: 2rem"
                        class="mr-2"></nb-icon>
                    <p
                        class="font-weight-bold text-muted mb-0"
                        style="font-size: 1.2rem">
                        Drop valid file(s) here or click to upload
                    </p>
                    <div></div>
                </div>
                <p class="text-muted mb-0">*File sizes large than 20MB will not be accepted</p>
            </div>

            <div class="mw-50 d-flex justify-content-between flex-wrap">
                @for (ext of extensions(); track ext) {
                    <nb-tag
                        class="mx-2"
                        status="basic"
                        [text]="ext"></nb-tag>
                }
            </div>
        </div>
    </ngx-dropzone-label>

    @for (file of files(); track file) {
        <ngx-dropzone-preview
            [removable]="true"
            (removed)="onFileRemove(file)"
            class="w-100 mb-2"
            style="max-height: 20px">
            <ngx-dropzone-label>
                <span class="font-weight-bold">{{ file.name }}</span>
                {{ file.size | fileSize }}
            </ngx-dropzone-label>
        </ngx-dropzone-preview>
    }
</ngx-dropzone>
